<p-table [rowHover]="true" #dt dataKey="Id" [value]="subFamilies" [loading]="loading" styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm">
	<ng-template pTemplate="header">
		<tr>
			<th>Famille</th>
			<th>Sous Famille</th>
			<th>Remise client supplémentaire</th>
			<th>Offres permanentes exclues</th>
			<th>Offres commerciales exclues</th>
			<th>Editeurs exclus</th>
			<th>Jeux exclus</th>
			<th></th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
		<tr (click)="selected = row.id_condition" [ngClass]="{'bg-yellow-800':selected == row.id_condition}">
			<td>
				<span class="text-xs">{{row.FamilyId}} - </span>
				{{row.FamilyCaption}}
			</td>
			<td>
				<span class="text-xs">{{row.SubFamilyId}} - </span>
				{{row.SubFamilyCaption}}
			</td>
			<ng-container >
				<td>
					<p-inputNumber [min]="0" [max]="100" [step]="0.01" inputStyleClass="w-3rem"  [(ngModel)]="row.discountRateGlobal"></p-inputNumber>
				</td>
				<td>
					<p-multiSelect [selectedItemsLabel]="'{0} sélectionnés'" [maxSelectedLabels]="1" appendTo="body" [options]="offers" [(ngModel)]="row.offer_excluded" optionLabel="name_offer" optionValue="id_offer"></p-multiSelect>
				</td>
				<td>
					<p-multiSelect [selectedItemsLabel]="'{0} sélectionnés'" [maxSelectedLabels]="1" appendTo="body" [options]="offersEbp" [(ngModel)]="row.offerEbp_excluded" optionLabel="Description" optionValue="Id"></p-multiSelect>
				</td>
				<td>
					<p-multiSelect [selectedItemsLabel]="'{0} sélectionnés'" [maxSelectedLabels]="1" appendTo="body" [options]="editors" [(ngModel)]="row.editor_excluded" optionLabel="name_editor" optionValue="id_editor"></p-multiSelect>
				</td>
				<td>
					<p-multiSelect [selectedItemsLabel]="'{0} sélectionnés'" [maxSelectedLabels]="1" appendTo="body" [options]="games" [(ngModel)]="row.item_excluded" optionLabel="name" optionValue="Id" [filter]="true" filterBy="name"></p-multiSelect>
				</td>
				<td>
					<button pButton icon="pi pi-save" (click)="save(row)"></button>
				</td>
			</ng-container>
		</tr>
	</ng-template>
</p-table>